<template>
  <span>
    <b-container fluid>
      <form @submit.prevent="onSubmit">
        <b-row class="table-header">
          <b-col cols="12" sm="12" lg="12">
            <b-form-group>
              <b-form-input
                ref="search"
                v-model="filter.user"
                :disabled="fetching"
                placeholder="user name / email"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="3">
            <b-form-group>
              <b-form-select
                :options="modules"
                :disabled="fetching"
                v-model="filter.module"
                @change="filterByModule"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="3">
            <b-form-group>
              <b-form-select
                :options="components"
                :disabled="fetching"
                v-model="filter.component"
                @change="filterByComponent"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="3">
            <b-form-group>
              <b-form-select
                :options="topics"
                :disabled="fetching"
                v-model="filter.topic"
                @change="filterByTopic"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="3" class="text-right">
            <b-form-group>
              <button class="btn btn-primary" type="submit">
                Run Report
              </button>
            </b-form-group>
          </b-col>
        </b-row>
      </form>

      <no-data v-if="noData" message="No completed knowledge checks found..." />

      <b-table
        v-if="items.length"
        :responseive="true"
        :busy="fetching"
        :items="items"
        :fields="reportFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged"
      >

        <template slot="knowledgecheck" slot-scope="data">
          <div>
            {{ data.item.module_name }} / {{ data.item.component_name }} <span v-if="data.item.topic_name">/ {{ data.item.topic_name }}</span>
          </div>
        </template>

        <template slot="completed_date_time" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div class="no-wrap text-right">
            <span v-b-tooltip.hover style="display:inline-block" title="view">
              <b-link
                :disabled="fetching"
                :to="{name: 'admin-reports-knowledgecheck-response-detail',params: {organizationId: organization.id, responseId: data.item.id}}"
                target="_blank"
                title="view"
                class="btn"
                variant="outline-secondary">

                <b-button
                  :disabled="fetching"
                  title="view"
                  variant="outline-secondary">

                  <i class="fas fa-file"></i>
                </b-button>
              </b-link>
            </span>
            <!-- <span v-b-tooltip.hover style="display:inline-block" title="download">
              <b-button
                :disabled="fetching"
                title="download"
                variant="outline-secondary"
                @click.stop="download(data.item)">
                <i class="fas fa-download"></i>
              </b-button>
            </span> -->
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="items.length > 0"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { readableDate } from '@/helpers'
import modulesApi from '@/api/modules'
import reportsApi from '@/api/knowledgechecks/reports'
import noData from '@/components/common/table/no-data'

export default {
  components: {
    noData
  },
  data() {
    return {
      components: [{ text: 'All Components', value: null }],
      topics: [{ text: 'All Topics', value: null }],
      fetching: false,
      filter: {
        module: null,
        component: null,
        topic: null,
        user:null,
        paginate:true
      },
      items: [],
      meta: {},
      modules:[{ text: 'All Modules', value: null }],
      reportFields: [
        { key: 'user_name', label: 'User', sortable: true },
        { key: 'knowledgecheck', label: 'Knowledge Check', sortable: false },
        { key: 'completed_date_time', label: 'Date', sortable: true },
        { key: 'score', label: 'Score', sortable: true },
        { key: 'actions', label: '', headerTitle:'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    noData() {
      if(this.fetching){
        return false
      }
      return !(this.items && this.items.length > 0)
    }
  },
  async mounted(){
    this.fetching = true

    const response = await modulesApi.index({tenantID: this.organization.id, order: 'name'})
    const names = response.data.data.map((module) => {
      return {
        text: module.name,
        value: module.id
      }
    })
    names.unshift({ text: 'All Modules', value: null })

    this.modules = names
    await this.runReport()
  },
  methods: {
    readableDate,
    async filterByModule(module) {
      this.fetching = true
      this.filter.module = module
      this.components = await reportsApi.getComponentOptions({
        tenantId: this.organization.id,
        moduleId: module
      })
      await this.runReport()
    },
    async filterByComponent(component) {
      this.fetching = true
      this.filter.component = component
      this.topics = await reportsApi.getTopicOptions({
        tenantId: this.organization.id,
        componentId: this.filter.component
      })
      await this.runReport()
    },
    async filterByTopic(topic) {
      this.filter.topic = topic
      await this.runReport()
    },
    async onSubmit(){
      this.runReport(1)
    },
    async runReport(page) {
      this.fetching = true
      this.filter.page = page || 1
      await this.getResults()
      this.fetching = false
    },
    async getResults() {
      const params = _.cloneDeep(this.filter)
      params.tenantId = this.organization.id

      const response = await reportsApi.completed(params)
      this.items = response.data.data
      this.meta = response.data.meta
    },
    viewReport(item){
      this.$router.push({name: 'admin-reports-knowledgecheck-response-detail',params: {organizationId: this.organization.id, responseId: item.id}})
    },
    download(item){
      alert(`download report for ${ item.id }`)
    },
    sortChanged (event) {
      this.filter.page = 1
      this.filter.order = event.sortBy
      this.filter.desc = event.sortDesc
      this.runReport()
    },
    pageChanged(page){
      this.runReport(page)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/reports/completed.vue